/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-case-declarations */
import { isEmpty, isUndefined, mapValues } from 'lodash';
import { all, create } from 'mathjs';
import { FULLY_DILUTED_OWNERSHIP_ROW_NUMBER } from 'common/constants/fund-ownership';
import { Logger } from 'utilities';
import { alphabetGenerator } from 'utilities/alphabet-utilities';
import { FundOwnershipCell, FundOwnershipConfigurationRow, ReverseParsedFundOwnershipDetail } from '../types';

const totalParser = ({ cells, columns, rows }: {
  cells: Record<string, FundOwnershipCell>;
  columns: ReverseParsedFundOwnershipDetail[];
  rows: FundOwnershipConfigurationRow[];
}) => {
  let totalsRow = {} as FundOwnershipConfigurationRow;
  const alphabet = alphabetGenerator([], columns.length);
  const math = create(all);

  const scope = mapValues(cells, cell => {
    // eslint-disable-next-line no-restricted-globals
    if (isUndefined(cell) || isNaN(cell.value as number)) return 0;
    return parseFloat(`${cell.value}`);
  });

  const sumExpr = (rowIndexAux: number) =>
    Object.keys(columns)
      .map((columnIndex) => alphabet[Number(columnIndex)] + rowIndexAux)
      .filter(key => cells[key]);

  rows.forEach(({ alias, hasTotal, format }, rowIndex) => {
    try {
      const columnLegend = alphabet[0];
      const rowIndexAux = rowIndex + 1;
      const keyActual = `${columnLegend + rowIndexAux}`;
      const key = `TOTAL_${columnLegend + rowIndexAux}`;

      const colFormat = format?.style;
      const gridFormat = colFormat && 'number';

      const fractionDigits = rowIndexAux === FULLY_DILUTED_OWNERSHIP_ROW_NUMBER ? 1 : 0;

      const isHeaderRow = rowIndex === 0;
      const cell = {
        ...rows[rowIndex],
        key: keyActual,
        isTotal: true,
        readOnly: true,
        alias,
        dataSourceKey: '',
        gridType: isHeaderRow ? undefined : gridFormat,
        className: isHeaderRow
          ? [rows[rowIndex].className?.replace('title-col', 'table-header'), 'total-cell'].filter(Boolean).join(' ')
          : [rows[rowIndex].className, 'total-cell'].join(' '),
        format: {
          style: colFormat,
          minimumFractionDigits: fractionDigits,
          maximumFractionDigits: fractionDigits,
          isDecimal: true,
        },
        expr: isHeaderRow ? 'Total' : undefined,
        valueViewer: isHeaderRow ? null : rows[rowIndex].valueViewer,
        dataEditor: isHeaderRow ? undefined : rows[rowIndex].dataEditor,
        component: isHeaderRow ? null : rows[rowIndex].component,
        linkedCellSymbols: undefined,
      };

      if (hasTotal) {
        cell.expr = `=sum(${sumExpr(rowIndexAux)})`;
      }

      if (isHeaderRow) {
        cell.value = 'Total';
      } else if (cell.expr && !isEmpty(scope)) {
        cell.value = math.evaluate(cell.expr.substring(1), scope) ?? 0;
      } else {
        cell.value = null;
      }

      totalsRow = {
        ...totalsRow,
        [key]: cell,
      };
    } catch (error) {
      Logger.error('error', error);
    }
  });
  return totalsRow;
};

export default totalParser;
